<script setup lang="ts">
import { computed } from 'vue'
import type { CSSProperties } from 'vue'

const props = defineProps<{
  style?: CSSProperties
  kind: 'rect' | 'ellipse'
  fill: string
  stroke: string
  strokeWidth: number
  radius: number
}>()

const borderRadius = computed(() => {
  if (props.kind === 'ellipse') return '9999px'
  return `${Math.max(0, props.radius)}px`
})

const style = computed<Record<string, string | number>>(() => ({
  ...(props.style as Record<string, string | number> | undefined),
  background: props.fill,
  border: `${Math.max(0, props.strokeWidth)}px solid ${props.stroke}`,
  borderRadius: borderRadius.value,
}))
</script>

<template>
  <div :style="style" />
</template>
